/* src/app/layout/blank-layout/blank-layout.component.scss */
.content-container {
  background-color: #FFFFFF;
  margin: 30px;
  margin-bottom: 60px;
}
/*# sourceMappingURL=blank-layout.component.css.map */
